import React from "react";
import pathRouts from "../../../../enums/pathRoute";
import NavigateLink from "../../../features/navigateLink/navigateLink";
import Text from "../../../features/text/Text";
import MessagesNotification from "../../../ui/messagesNotification/MessagesNotification";
import iconsList from "../../../ui/icons/iconsList";
import Tooltip from "../../../ui/tooltip/Tooltip";
import classes from "./DomainCard.module.css";

const DomainCard = ({ domain, link }) => {
    const imgSrc = domain?.cardDomainImg || domain?.matriculation?.cardDomainImg;
    const teachersNames = (domain?.teachers || [])
        .map(t => t.firstName && t.lastName ? `${t.firstName} ${t.lastName}` : t.name)
        .join(", ");

    return (
        <NavigateLink link={link ?? `/${pathRouts.MYLEARNING}/domain/${domain?.nmmId}/${domain?.name}`} showLoadingPage={false}>
            <div className={classes.DomainCard}>
                <img src={imgSrc} className={classes.DomainImg} alt="" />
                <div className={classes.Content}>
                    <div className={classes.DomainTitle}>
                        <Text>{domain?.text}</Text>
                    </div>
                    {teachersNames &&
                        <Tooltip showTooltip={true} text={teachersNames}>
                        <div className={classes.DomainTeachers}>
                                <Text>{teachersNames}</Text>
                            </div>
                        </Tooltip>
                }
                </div>
                {domain?.hasUnreadMessages &&
                    <MessagesNotification name={iconsList.messages} size="18px" />
                }
            </div>
        </NavigateLink>
    );
};

export default DomainCard;
